import useProtectionPlanStore from '~/stores/useProtectionPlanStore';
import { computed } from 'vue';
import { useProduct } from '~/modules/product/composables/useProduct';

export function useSelectedProtectionPlan(initialValue) {
  const store = useProtectionPlanStore();
  const { productId } = useProduct();

  const getSelectedProtectionPlan = () => store.selectedProtectionPlan?.[productId] || '';

  /**
   * @param {String} selectedPlanId
   * @returns {void}
   */
  const updateSelectedProtectionPlan = (selectedPlanId = '') => {
    if (selectedPlanId) {
      store.selectedProtectionPlan[productId] = selectedPlanId;
    } else {
      delete store.selectedProtectionPlan[productId];
    }
  };

  if (initialValue && !getSelectedProtectionPlan()) {
    updateSelectedProtectionPlan(initialValue);
  }

  const protectionPlan = computed({
    get: getSelectedProtectionPlan,
    set: updateSelectedProtectionPlan,
  });

  return { updateSelectedProtectionPlan, getSelectedProtectionPlan, protectionPlan };
}

export default useSelectedProtectionPlan;
